<template>
  <div class="p-6 border-b border-[#1c4848]/5">
    <div class="flex items-center justify-between mb-4">
      <h2 class="text-sm font-bold tracking-wide uppercase text-[#1c4848]/80">
        {{ title }}
      </h2>
      <div class="flex items-center">
        <slot name="actions">
          <button
            type="button"
            class="p-1.5 hover:bg-[#1c4848]/5 rounded-lg text-[#1c4848]/60 transition-colors"
            aria-label="More options"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
          </button>
        </slot>
      </div>
    </div>
    <slot />
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, default: 'Pages' }
});
</script>
